import React from 'react';

function Contact() {
  return (
    <div className='max-w-2xl mx-auto p-4'>
      <h2 className='text-3xl font-bold mb-4 mt-4'>Contact Us</h2>

      <section className='mb-8'>
        <p className='mb-4'>
          Have questions, feedback, or need help with Pikchar? We're here for
          you. Reach out to us anytime using the details below, and our team
          will get back to you as soon as possible.
        </p>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>Email Support</h3>
        <p className='mb-2'>
          For general inquiries, technical support, or account-related questions:
        </p>
        <p className='font-semibold'>pikcharxdynamix@gmail.com</p>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>Report a Problem</h3>
        <p>
          Facing an issue with video playback, login, subscription, or anything
          else? Email us with a detailed explanation and screenshots if
          possible. This helps us resolve your issue faster.
        </p>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>Feedback & Suggestions</h3>
        <p>
          We love hearing your ideas. If you have feature requests or suggestions
          to improve Pikchar, feel free to reach out. Your feedback helps make
          the app better for everyone.
        </p>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>Response Time</h3>
        <p>
          Our support team usually responds within 24 to 48 hours. In some cases,
          it may take a bit longer, but we promise we’ll get back to you.
        </p>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>Thank You</h3>
        <p>
          Thank you for using Pikchar. We're committed to giving you the best
          experience possible and appreciate your support.
        </p>
      </section>
    </div>
  );
}

export default Contact;
